
import React from 'react';
import { UCAModule, CommonModule } from "uca-react-containers-library";
import Loader from './loader';

const AccountSettingsComponent = () => {
    const {isLoading } = CommonModule.useAuth();
    const { saveRouteData } = CommonModule.useRoute();
    const { appData } = CommonModule.useApp();
    const heading = !appData.isBusinessBanner ?  'Personal Info' : 'Account Settings';
    
    React.useEffect(() => {
        saveRouteData({ 'currentPage': heading });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (isLoading) return <Loader></Loader>;

    return (
        <CommonModule.ViewportProvider>
            <div class="col-lg-3 col-xl-3">
                <UCAModule.LeftNavigation></UCAModule.LeftNavigation>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9">
                <UCAModule.AccountSettingsV2 />
            </div>
        </CommonModule.ViewportProvider>
    );
};

export default AccountSettingsComponent;
